import "./LoadingScreen.scss";

export const LoadingScreen = ({ title = "Cargando" }) => {
    return (
        <div className="loading-screen" role="status" aria-live="polite">
            <div className="loading-screen__container">
                <div className="loading-screen__spinner">
                    <div className="loading-screen__spinner-circle"></div>
                    <div className="loading-screen__spinner-circle loading-screen__spinner-circle--2"></div>
                    <div className="loading-screen__spinner-circle loading-screen__spinner-circle--3"></div>
                </div>
                <div className="loading-screen__content">
                    <h2 className="loading-screen__title">{title}</h2>
                    <div className="loading-screen__dots">
                        <span className="loading-screen__dot"></span>
                        <span className="loading-screen__dot"></span>
                        <span className="loading-screen__dot"></span>
                    </div>
                </div>
            </div>
        </div>
    );
};
